@if ((panelLateralService.isOpen$ | async) && (panelLateralService.mode$ | async) === 'modal') {
  <button type="button" aria-label="Cerrar panel" class="fixed z-30 inset-0 bg-black opacity-50"
    (click)="panelLateralService.close()"></button>
}

<div class="fixed z-40 h-full pt-4 overflow-y-auto bg-white right-0 top-0 border-l-2 w-vista-previa-{{size}} flex flex-col"
  [class.panel-citation]="(panelLateralService.isCitationOpen$ | async)"
  [ngClass]="(panelLateralService.isOpen$ | async) ? 'open' : 'side-panel'">
  <div class="border-b-2 flex justify-between items-center gap-3">
    <h5 #tituloPanel tabindex="-1" id="drawer-right-label" class="mb-4 font-semibold text-xl ml-3 min-w-0 truncate" [title]="titulo">
      {{ titulo }}
    </h5>
    <button type="button" (click)="panelLateralService.close()" aria-label="Cerrar panel"
      class="shrink-0 cursor-pointer text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 me-3 -mt-1.5">
      <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clip-rule="evenodd"></path>
      </svg>
    </button>
  </div>
  <div class="flex-1 min-h-0 overflow-y-auto">
    <ng-template #container></ng-template>
  </div>
</div>
